export const inspectTable = [
  {
    title: "밀폐공간작업 프로그램 수립·시행(제619조 제3항)",
    content: "사업장 내 밀폐공간 위치 및 해당 공간 내 위험성* 파악 여부\n" +
      "* 산소결핍, 황화수소, 일산화탄소, 아르곤 등",
    isChecked: "",
  },
  {
    title: "밀폐공간작업 프로그램 수립·시행(제619조 제3항)",
    content: "사업주 또는 관리책임자가 유해가스 농도 및 환기상태 등 작업장 상황을 확인 후 작업을 허가하는 내부규정(절차)이 마련되어 있는지 여부",
    isChecked: "",
  },
  {
    title: "출입금지조치(제622조)",
    content: "출입금지조치(제622조)",
    isChecked: "",
  },
  {
    title: "출입금지조치(제622조)",
    content: "시건조치(잠금장치) 여부",
    isChecked: "",
  },
  {
    title: "안전보건조치(제619조의 2~제620조)",
    content: "밀폐공간 작업 전, 작업 중 산소 및 유해가스 농도측정 및 적정공기 상태 확인 여부\n" +
      "※ ① 산 소 : 18.0 ~ 23.5%\n" +
      " ② 황화수소 : 10 ppm 미만\n" +
      " ③ 탄산가스(이산화탄소) : 1.5% 미만\n" +
      " ④ 일산화탄소 : 30 ppm미만",
    isChecked: "",
  },
  {
    title: "안전보건조치(제619조의 2~제620조)",
    content: "밀폐공간 작업 전, 작업 중 환기팬을 이용한 환기 여부",
    isChecked: "",
  },
  {
    title: "안전보건조치(제619조의 2~제620조)",
    content: "적정공기가 아닌 상태에서 작업 시 송기마스크나 공기호흡기 사용 여부",
    isChecked: "",
  },
  {
    title: "인원의 점검(제621조)",
    content: "밀폐공간 작업 시 입·출입 근로자 인원 점검 여부",
    isChecked: "",
  },
  {
    title: "감시인 배치(제623조)",
    content: "밀폐공간 작업 시 감시인 배치 여부",
    isChecked: "",
  },
  {
    title: "대피용 기구의 비치(제625조)",
    content: "송기마스크(또는 공기호흡기) 비치 여부 확인",
    isChecked: "",
  },
  {
    title: "안전한 작업 방법 교육(제641조)",
    content: "밀폐공간 작업 전 작업자와 감시인에게 안전하게 작업하는 방법을 주지하는지 여부\n" +
      "※ 유해가스 측정, 환기설비 가동, 보호구 착용, 사고시 응급조치, 구조요청 절차 등",
    isChecked: "",
  },
  {
    title: "필수장비 지급 확인",
    content: "산소 및 유해가스 측정기",
    isChecked: "",
  },
  {
    title: "필수장비 지급 확인",
    content: "환기설비(송풍기 등), 발전기(또는 배터리)",
    isChecked: "",
  },
  {
    title: "필수장비 지급 확인",
    content: "송기마스크 또는 공기호흡기",
    isChecked: "",
  },
];
